/* 
 *  This file business-region.model.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2025  
 *  (C) 2015-2025. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { PaginationModel, LinksModel } from '../../../../../global/models/common.models';
import { FormControl } from '@angular/forms';

export enum businessRegionUrls {
    businessRegionList = '/api/core/BusinessRegion',
    businessRegionSearch = '/api/core/BusinessRegion/Search',
    businessRegionInsert = '/api/core/BusinessRegion',
    businessRegionUpdate = '/api/core/BusinessRegion',
    businessRegionDelete = '/api/core/BusinessRegion',
    employeeCount = '/api/core/BusinessRegion/EmployeeCount',
    totalCount = '/api/core/BusinessRegion/TotalCount'
}

export interface BusinessRegionGridRequestModel {
    businessRegionCode: string;
    status: string;
    pagination: PaginationModel;
}

export const businessRegionGridRequestData: BusinessRegionGridRequestModel = {
    businessRegionCode: '',
    status: '1',
    pagination: {
        pageNumber: 1,
        pageSize: 15
    }
};

export interface BusinessRegionModel {
    businessRegionCode?: string;
    businessRegionName?: string;
    countryCode?: string;
    activeStatus?: string;
}

export interface BusinessRegionGridResponseModel {
    businessRegionCode?: string;
    businessRegionName?: string;
    countryCode?: string;
    countryName?: string;
    internationalCode?: string;
    nationality?: string;
    activeStatus?: string;
    globalRegionId?: number;
    globalRegionCode?: string;
    globalRegionName?: string;
    links?: LinksModel[];
    employeeCountLink?: string;
    employeeCount?: string;
}

export const businessRegionFormEmptyData: BusinessRegionModel = {
    businessRegionCode: '',
    businessRegionName: '',
    countryCode: '',
    activeStatus: '1'
};

export interface BusinessRegionFilterModel {
    selected_business_region: Array<{ key: string; value: string }>;
    active: boolean;
    inactive: boolean;
}

export const businessRegionFilterSkeleton: BusinessRegionFilterModel = {
    selected_business_region: [] as Array<{ key: string; value: string }>,
    active: true,
    inactive: false
};

// Form interface for type safety
export interface BusinessRegionFormInterface {
    businessRegionCode: FormControl<string | null>;
    businessRegionName: FormControl<string | null>;
    globalRegionCode: FormControl<string | null>;
    countryCode: FormControl<string | null>;
    countryName: FormControl<string | null>;
    activeStatus: FormControl<string | null>;
}

// Interface for dropdown options
export interface DropdownOption {
    key: string;
    value: string;
}

// Interface for button config
export interface ButtonConfig {
    text: string;
    index: number;
}
